import RegisterIndustryVisitor from './RegisterIndustryVisitor';

export default RegisterIndustryVisitor;
